/* SELINX CLOTHING — theme.js */
(function () {
  'use strict';

  var CFG = window.SELINX || {};
  var routes = CFG.routes || { cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart: '/cart.js' };

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || CFG.moneyFormat || '&#8377;{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(n, d) { return (n === undefined || n === null) ? d : n; }
    function thousands(num, precision, thousand, decimal) {
      precision = defaultTo(precision, 2);
      thousand = defaultTo(thousand, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(num) || num === null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'"); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.selinxMoney = formatMoney;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- header ---------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- announcement rotator ---------------- */
  var ann = $$('[data-announce-item]');
  if (ann.length > 1) {
    var ai = 0;
    setInterval(function () {
      ann[ai].classList.remove('is-active');
      ai = (ai + 1) % ann.length;
      ann[ai].classList.add('is-active');
    }, 4200);
  }

  /* ---------------- mobile nav ---------------- */
  var mnav = $('[data-mnav]');
  function setLock(on) { document.body.classList.toggle('is-locked', !!on); }
  $$('[data-mnav-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (mnav) { mnav.classList.add('is-open'); setLock(true); } });
  });
  $$('[data-mnav-close]').forEach(function (b) {
    b.addEventListener('click', function () { if (mnav) { mnav.classList.remove('is-open'); setLock(false); } });
  });

  /* ---------------- cart drawer ---------------- */
  var drawer = $('[data-drawer]');
  var overlay = $('[data-overlay]');
  var drawerBody = $('[data-drawer-body]');
  var drawerFoot = $('[data-drawer-foot]');
  var freeShipThreshold = parseInt(CFG.freeShipThreshold || 0, 10);

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-on');
    setLock(true);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-on');
    setLock(false);
  }
  $$('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); getCart().then(renderCart); });
  });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); if (mnav) { mnav.classList.remove('is-open'); setLock(false); } }
  });

  function getCart() {
    return fetch(routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-visible', n > 0);
    });
  }

  function esc(s) { return String(s === undefined || s === null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawerBody) return;

    if (!cart.items || !cart.items.length) {
      drawerBody.innerHTML =
        '<div class="drawer__empty"><p>Your bag is empty.</p>' +
        '<a class="btn btn--ghost" href="' + (CFG.shopAllUrl || '/collections/all') + '"><span>Start shopping</span></a></div>';
      if (drawerFoot) drawerFoot.innerHTML = '';
      var shipEl0 = $('[data-ship]');
      if (shipEl0) shipEl0.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_240x300_crop_center$1$2') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      html +=
        '<div class="citem" data-line="' + (i + 1) + '">' +
        '<a class="citem__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div>' +
        '<a class="citem__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant ? '<div class="citem__v">' + esc(variant) + '</div>' : '') +
        '<div class="citem__row">' +
        '<div class="qty qty--sm">' +
        '<button type="button" data-qty="-1" aria-label="Decrease">&minus;</button>' +
        '<input type="number" value="' + it.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
        '<button type="button" data-qty="1" aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="citem__p">' + formatMoney(it.final_line_price) + '</div>' +
        '</div>' +
        '<button type="button" class="citem__x" data-remove>Remove</button>' +
        '</div></div>';
    });
    drawerBody.innerHTML = html;

    if (drawerFoot) {
      drawerFoot.innerHTML =
        '<div class="drawer__tot"><span>Subtotal</span><b>' + formatMoney(cart.total_price) + '</b></div>' +
        '<a class="btn btn--full" href="/checkout"><span>Checkout</span></a>' +
        '<a class="btn btn--ghost btn--full" href="/cart"><span>View bag</span></a>' +
        '<div class="drawer__note">Taxes included. Shipping calculated at checkout.</div>';
    }

    var shipEl = $('[data-ship]');
    if (shipEl) {
      if (freeShipThreshold > 0) {
        shipEl.style.display = '';
        var left = freeShipThreshold - cart.total_price;
        var pct = Math.min(100, Math.round((cart.total_price / freeShipThreshold) * 100));
        var msg = left > 0
          ? 'You are ' + formatMoney(left) + ' away from free shipping'
          : 'Congratulations — you have unlocked free shipping';
        shipEl.innerHTML = msg + '<div class="bar"><i style="width:' + pct + '%"></i></div>';
      } else {
        shipEl.style.display = 'none';
      }
    }
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var item = e.target.closest('[data-line]');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = $('[data-qty-input]', item);
      if (e.target.matches('[data-remove]')) { changeLine(line, 0); return; }
      var step = e.target.getAttribute('data-qty');
      if (step) {
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(step, 10));
        changeLine(line, next);
      }
    });
    drawerBody.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var item = e.target.closest('[data-line]');
      changeLine(parseInt(item.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  function addToCart(id, qty, btn) {
    var label = btn ? $('span', btn) : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.setAttribute('disabled', ''); if (label) label.textContent = 'Adding…'; }
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
        return getCart().then(function (cart) { renderCart(cart); openDrawer(); });
      })
      .catch(function (err) {
        var box = btn ? btn.closest('form') : null;
        if (box) {
          var e1 = $('.form-err', box);
          if (!e1) { e1 = document.createElement('div'); e1.className = 'form-err'; box.appendChild(e1); }
          e1.textContent = err.message;
        }
      })
      .then(function () {
        if (btn) { btn.removeAttribute('disabled'); if (label) label.textContent = original; }
      });
  }

  /* product form submit */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = $('[name="id"]', form).value;
      var qtyEl = $('[name="quantity"]', form);
      addToCart(id, qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1, $('[data-atc]', form));
    });
  });

  /* quick add buttons */
  $$('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(btn.getAttribute('data-quick-add'), 1, btn);
    });
  });

  /* ---------------- qty steppers (non-drawer) ---------------- */
  $$('[data-qty-wrap]').forEach(function (wrap) {
    wrap.addEventListener('click', function (e) {
      var step = e.target.getAttribute('data-qty');
      if (!step) return;
      var input = $('input', wrap);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step, 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------------- gallery ---------------- */
  $$('[data-gallery]').forEach(function (gal) {
    var main = $('[data-gal-main]', gal);
    $$('[data-gal-thumb]', gal).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.srcset = t.getAttribute("data-srcset") || ""; main.src = t.getAttribute("data-src"); }
        $$('[data-gal-thumb]', gal).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* ---------------- variant picker ---------------- */
  $$('[data-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse($('[data-variant-json]', root).textContent); } catch (err) { return; }
    var idInput = $('[name="id"]', root);
    var priceEl = $('[data-v-price]', root);
    var compareEl = $('[data-v-compare]', root);
    var stockEl = $('[data-v-stock]', root);
    var atc = $('[data-atc]', root);
    var stickyPrice = $('[data-sticky-price]');

    function select(variant, btn) {
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        var txt = 'In stock — ready to ship';
        if (!variant.available) { stockEl.classList.add('is-out'); txt = 'Sold out'; }
        else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stockEl.classList.add('is-low'); txt = 'Low stock — only ' + variant.inventory_quantity + ' left';
        }
        $('span', stockEl).textContent = txt;
      }
      if (atc) {
        var lab = $('span', atc);
        if (!variant.available) { atc.setAttribute('disabled', ''); if (lab) lab.textContent = 'Sold out'; }
        else { atc.removeAttribute('disabled'); if (lab) lab.textContent = CFG.atcLabel || 'Add to bag'; }
      }
      if (btn) {
        $$('[data-variant-id]', root).forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-variant-id]', root).forEach(function (btn) {
      var v = data.filter(function (x) { return String(x.id) === btn.getAttribute('data-variant-id'); })[0];
      if (v && !v.available) btn.classList.add('is-off');
      btn.addEventListener('click', function () { select(v, btn); });
    });
  });

  /* ---------------- accordion ---------------- */
  $$('[data-acc-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc__item');
      var open = item.classList.contains('is-open');
      item.classList.toggle('is-open', !open);
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  /* ---------------- sticky atc ---------------- */
  var sticky = $('[data-sticky-atc]');
  var buybox = $('[data-buybox]');
  if (sticky && buybox) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(buybox);
    $$('[data-sticky-go]', sticky).forEach(function (b) {
      b.addEventListener('click', function () {
        var form = $('[data-product-form]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });
  }

  /* ---------------- reveal ---------------- */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.rv').forEach(function (el) { ro.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------- collection sort ---------------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* init count on load */
  if (typeof CFG.cartCount !== 'undefined') updateCount(CFG.cartCount);

  /* ---------------- hero front/back auto swap ---------------- */
  $$('[data-hero-swap]').forEach(function (media) {
    var shots = $$('[data-hero-shot]', media);
    if (shots.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var delay = parseInt(media.getAttribute('data-delay'), 10) || 4000;
    var i = 0;
    setInterval(function () {
      shots[i].classList.remove('is-active');
      i = (i + 1) % shots.length;
      shots[i].classList.add('is-active');
    }, delay);
  });
})();
